import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { NumberOfTransactionsOptions } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const AverageNumberOfTransactionsSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(NumberOfTransactionsOptions).map((key) => ({
        id: key,
        label: t(`intake_form.number_of_transactions.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default AverageNumberOfTransactionsSelect;
